import { ApiResponse, Workspace } from '../types';
import { apiService } from './api';

class WorkspaceService {
  /**
   * List all workspaces for the authenticated user
   */
  async listWorkspaces(): Promise<ApiResponse<Workspace[]>> {
    try {
      // The apiService will automatically handle the base URL and auth token.
      const response = await apiService.get<{ success: boolean; data: Workspace[] }>('/workspaces');
      return { success: response.success || true, data: response.data || [] };
    } catch (error: unknown) {
      console.error('Failed to fetch workspaces:', error);
      const err = error as { response?: { data?: { message?: string } }; message?: string };
      return { 
        success: false, 
        data: [], 
        error: err.response?.data?.message || err.message || 'Failed to fetch workspaces'
      };
    }
  }

  /**
   * Get a specific workspace by ID
   */
  async getWorkspace(workspaceId: string): Promise<ApiResponse<Workspace>> {
    // The apiService will automatically handle the base URL and auth token.
    const response = await apiService.get<Workspace>(`/workspaces/${workspaceId}`);
    return { success: true, data: response };
  }
}

export const workspaceService = new WorkspaceService();
